export default function dots(text) {
  const sliced = text.slice(0, 20)
  if (sliced.length < text.length) {
    return sliced + '...'
  }
  return sliced
}
